(function() {
  'use strict';

  angular
    .module('admin.checklist_report.service', [])
    .factory('ChecklistReportService', ChecklistReportService);

  /** @ngInject */
  function ChecklistReportService($http, $q, API) {

    function list(startDate, endDate, cs, comp, qua, view, cds, start, limit){
      var defered = $q.defer();
      if (isNaN(cds)) {
        cds = ''
      }

      $http.get(API.API_URL + 'admin/checklists/report?start-date=' + startDate + '&end-date=' + endDate + '&cs=' + cs + '&comp=' + comp + '&qua=' + qua + '&view=' + view + '&cds=' + cds + '&sort=id-desc' + '&start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    return{
      list: list
    };

  }

})();
